import _ from 'underscore';
import { HISTORY_PAGE_TAB_TYPES } from '@bingads-webui-campaign/recommendation-core';

export class RecommendationHistoryGridService {
  constructor(recommendationService, currentActivity) {
    this.recommendationService = recommendationService;
    this.currentActivity = currentActivity;
  }

  findAll(op) {
    return this.recommendationService.getHistory().then((res) => {
      if (_.isFunction(this.currentActivity.trace)) {
        this.currentActivity.trace(
          'view history page',
          'recommendation/history'
        );
      }
      const { data } = res;

      // filter item with 'RSA auto upgrade' editorName
      data.value = _.filter(data.value, rec => rec.EditorName !== 'RSA auto upgrade');

      let gridData;

      if (_.isEmpty(data.value)) {
        gridData = [];
        gridData.totalCount = 0;
      } else if (op.selectedTab && op.selectedTab !== HISTORY_PAGE_TAB_TYPES.ALL) {
        gridData = _.filter(data.value, rec => (op.selectedTab === HISTORY_PAGE_TAB_TYPES.MANUAL ?
          !rec.IsAARSuperUser : rec.IsAARSuperUser));
        gridData.totalCount = gridData.length;
      } else {
        gridData = data.value;
        gridData.totalCount = gridData.length;
      }

      return gridData;
    });
  }
}
